import {
  Compass,
  Workflow,
  LineChart,
  Target,
  MessageCircleHeart,
  Sparkles,
  Scale,
  Headphones,
  Share2,
} from "lucide-react";

const MAP = {
  Compass,
  Workflow,
  LineChart,
  Target,
  MessageCircleHeart,
  Sparkles,
  Scale,
  Headphones,
  Share2,
};

export default function AgentIcon({ name, className = "w-5 h-5" }) {
  const Cmp = MAP[name] || Compass;
  return <Cmp className={className} />;
}
